<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Προσθήκη υποκατηγορίας EA / NACE</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη EA / NACE
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Όνομα" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Όνομα" v-model="name" horizontal></CInput>
              <label class="requiredLabel">Πρότυπο ISO</label>
              <multiselect 
                v-model="iso"
                id="iso"
                :options="isoOptions" 
                :disabled="disabled"
                label="label" 
                track-by="label"
                class="mb-3"
              ></multiselect>
              <CCol tag="label" sm="3" class="requiredLabel col-form-label p-0 mb-4">
                Ενεργό
              </CCol>
              <CSwitch :checked.sync="active" id="active" shape="pill" color="success" class="pt-2" v-model="active" /><br>
            <CButton color="primary" @click="storeSubcategory()">Δημιουργία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'CreateSubcategory',
  props: {
    caption: {
      type: String,
      default: 'Create Subcategory'
    },
  },
  components: {
    Multiselect,
  },
  data: () => {
    return {
        name: '',
        iso: '',
        isoOptions: [],
        active: true,
        disabled: false,
        showMessage: false,
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/services'})
    },
    storeSubcategory() {
        let self = this;
        let service = self.iso.value;
        axios.post('/api/servicesubcategories?token=' + localStorage.getItem("api_token"),
        {
          name: self.name,
          service: service,
          active: self.active,
        })
        .then(function (response) {
            self.name = '';
            self.iso = self.isoOptions[0];
            self.active = '';
            self.message = 'Επιτυχής καταχώρηση υποκατηγορίας.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/servicesubcategories/create?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.isoOptions = response.data.services.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      if (self.$route.params.id) {
        let id = parseInt(self.$route.params.id);
        self.iso = self.isoOptions.find((item) => item.value == id);
        self.disabled = true;
      } else {
        self.iso = self.isoOptions[0];
      }
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
